'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M94.9 193.2l86.1 86.2 8.6 8.6-1.9 12.1-19 120.3 95.4-48.6 0-272-31.4 61.5-5.6 10.9-12.1 1.9-120.3 19.1z', 'M309.6-10.9L288.2-52.8c-5.9 11.7-36.8 72.1-92.6 181.4-121.2 19.3-188.2 29.9-201.1 32 9.2 9.3 57.2 57.3 143.9 144.1-19.1 121.2-29.7 188.2-31.7 201.2 11.7-5.9 72.2-36.7 181.5-92.3 109.3 55.6 169.8 86.4 181.5 92.3-2-12.9-12.6-80-31.7-201.2 86.7-86.8 134.7-134.8 143.9-144.1-12.9-2.1-80-12.7-201.1-32L309.6-10.9zM264.2 99.8l0 272-95.4 48.6 19-120.3 1.9-12.1-8.6-8.6-86.1-86.2 120.3-19.1 12.1-1.9 5.6-10.9 31.4-61.5zm48 272l0-272 31.4 61.5 5.6 10.9 12.1 1.9 120.3 19.1-86.1 86.2-8.6 8.6 1.9 12.1 19 120.3-95.4-48.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;